import { Component, Vue } from 'vue-property-decorator';
import Cookies from 'js-cookie';
import moment from 'moment';

@Component({
  filters: {
    local_hyphen_time(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD');
    },
    local_time_str(val: number) {
      return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
    mnt_to_hour(val: number) {
      if (val) {
        return (val / 60 / 60).toFixed(2);
      } else {
        return val;
      }
    },
    hour_mnt(seconds: number) {
      if (seconds) {
        let h = Math.floor(seconds / 60 / 60);
        let m = Math.floor((seconds / 60) % 60);
        if (h < 1) {
          return m + '分钟';
        } else {
          return h + '小时' + m + '分钟';
        }
      } else {
        return seconds;
      }
    },
  },
})
export class PageQuery extends Vue {
  public total = 0;
  public page_query = {
    page: 1,
    page_size: Number(Cookies.get('page_size_ck')) || 30,
  };
  public pageFn!: Function;

  handleSizeChange(val: number) {
    Cookies.set('page_size_ck', val.toString());
    this.page_query.page_size = val;
    this.page_query.page = 1;
    this.pageFn && this.pageFn();
  }
  handleCurrentChange(val: number) {
    this.page_query.page = val;
    this.pageFn && this.pageFn();
  }
}
